<template>
  <MUIDialog
    class="mui-dialog--feedback"
    data-html2canvas-ignore="true"
    :acceptItem="acceptItem"
    :acceptOnEnter="false"
    :dismissItem="dismissItem"
    :displayType="displayType"
    :title="title"
    ref="dialog">
    <div class="input--placeholder" v-show="!comment">{{placeholder || defaultPlaceholder}}</div>
    <textarea name="comment" v-model.trim="comment" ref="comment"></textarea>
    <span v-if="error.comment" class="help is-danger">{{error.comment[errors[0]]}}</span>
  </MUIDialog>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  MUIDialog
} from '../components'
import {
  errorMessages
} from '@/utils'
import { ADD_NOTIFICATION } from '../modules/mutation-types'

import { APP } from '../config'
import firebase from '@firebase/app'
import '@firebase/database'

export default {
  components: {
    MUIDialog
  },
  props: [
    'placeholder'
  ],
  computed: {
    ...mapGetters([
      'isSizeClassRegular'
    ]),
    error () {
      return this.errors.length > 0 && errorMessages().feedback
    }
  },
  data () {
    return {
      acceptItem: {
        name: 'Send',
        fn: () => {
          this.acceptHandler()
        }
      },
      comment: null,
      defaultPlaceholder: 'Describe your issue or share your idea...',
      dismissItem: {
        name: 'Cancel'
      },
      displayType: APP,
      errors: [],
      title: 'Send Feedback'
    }
  },
  methods: {
    acceptHandler () {
      if (!this.comment) this.errors.push('required')
      if (this.errors.length > 0) return

      this.pushToFirebase()
    },
    pushToFirebase () {
      const application = {
        name: 'web',
        version: '102'
      }
      var comment = this.comment + '\n\n----\n' + window.location.href
      var feedback = {
        addedAt: firebase.database.ServerValue.TIMESTAMP,
        application,
        comment,
        device: this.$store.state.device,
        metadata: {
          href: window.location.href
        },
        url: window.location.href,
        user: {
          email: this.$store.state.User.email,
          uid: this.$store.state.User.uid
        }
      }

      var feedbackRef = firebase.database().ref(`/feedback`)
      feedbackRef.push(feedback)
        .then(snapshot => {
          this.$refs.dialog.close()
          this.$store.commit(ADD_NOTIFICATION, {
            message: 'Feedback sent'
          })
        }).catch(error => {
          this.$refs.dialog.close()
          this.$store.commit(ADD_NOTIFICATION, {
            message: 'Feedback unable to be sent at this time'
          })
          console.error(error)
        })
    }
  },
  mounted () {
    this.comment = null
    if (this.isSizeClassRegular) this.$refs.comment.focus()
  },
  watch: {
    comment () {
      if (!this.comment) return
      this.errors.pop('required')
      this.errors = [...new Set(this.errors)]
    }
  }
}
</script>

<style lang="sass" scope>
.mui-dialog--feedback
  .device__viewport-class--regular &
    width: 360px
  .mui-dialog__body
    padding: 0
  .input--placeholder, textarea
    padding: 24px
    line-height: 30px
  .input--placeholder
    pointer-events: none
    position: absolute
</style>



// WEBPACK FOOTER //
// src/views/Feedback.vue